import { Link, useLocation } from "react-router-dom";

export default function Layout({ children }) {
  const location = useLocation();
  const isAdmin = location.pathname === "/admin";

  return (
    <div className="min-h-screen bg-white text-[#131313] flex flex-col">
      <header
        data-testid="site-header"
        className="fixed top-0 left-0 right-0 z-50 bg-white/60 backdrop-blur-md"
      >
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <Link
            to="/"
            data-testid="brand-logo"
            className="font-mono-x text-xs font-medium uppercase tracking-[2.5px] text-[#131313]"
          >
            GLYDELABS
          </Link>
          {!isAdmin && (
            <nav className="flex items-center gap-6 md:gap-10">
              <Link
                to="/register"
                data-testid="nav-early-access-button"
                className="font-mono-x text-[11px] uppercase tracking-[1.6px] text-[#131313] border border-[#131313]/20 rounded-full px-5 py-2.5 hover:bg-[#131313] hover:text-white transition-colors"
              >
                Get Early Access
              </Link>
            </nav>
          )}
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer data-testid="site-footer" className="py-10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 flex items-center justify-between">
          <span className="font-mono-x text-[10px] uppercase tracking-[2px] text-[#9c9c9c]">
            GLYDELABS
          </span>
          <span className="font-mono-x text-[10px] uppercase tracking-[2px] text-[#9c9c9c]">
            Research in progress
          </span>
        </div>
      </footer>
    </div>
  );
}
